import React, { useState } from 'react';
import { Star } from 'lucide-react';

// Affichage en lecture seule d'une note sur 5.
export function StarsDisplay({ value = 0, size = 14, showValue = false }) {
  const v = Math.round(Number(value) || 0);
  return (
    <span
      style={{ display: 'inline-flex', alignItems: 'center', gap: 2, color: '#f5b041', verticalAlign: 'middle' }}
      aria-label={`${Number(value) || 0}/5`}
    >
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} size={size} fill={i <= v ? 'currentColor' : 'none'} aria-hidden="true" />
      ))}
      {showValue && (
        <span style={{ marginInlineStart: 4, fontSize: '0.82rem', fontWeight: 700, color: 'var(--gray-600)' }}>
          {Number(value).toFixed(1)}
        </span>
      )}
    </span>
  );
}

// Saisie d'une note : étoiles cliquables avec survol.
export function StarInput({ value = 0, onChange, size = 24 }) {
  const [hover, setHover] = useState(0);
  const current = hover || value;
  return (
    <span style={{ display: 'inline-flex', gap: 4 }} role="radiogroup" aria-label="Note sur 5">
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          onClick={() => onChange(i)}
          onMouseEnter={() => setHover(i)}
          onMouseLeave={() => setHover(0)}
          aria-label={`${i}/5`}
          aria-checked={value === i}
          role="radio"
          style={{
            background: 'none', border: 'none', padding: 2, cursor: 'pointer',
            color: i <= current ? '#f5b041' : 'var(--gray-300, #cbd5e1)',
            transition: 'transform 0.1s ease',
            transform: i <= current ? 'scale(1.08)' : 'none',
          }}
        >
          <Star size={size} fill={i <= current ? 'currentColor' : 'none'} />
        </button>
      ))}
    </span>
  );
}
